import * as Blockly from 'blockly';

// El legacy aparta un bloque de valor desplazado por otro. La v13 lo reengancha
// dentro del bloque nuevo si tiene una sola entrada compatible: en el tutorial
// "Robot clasificador" la comparacion `0 = 0` quedaba escondida dentro del
// bloque de color. Los bloques de sentencia siguen reenganchandose en la pila.
const { Connection } = Blockly;
const original = Connection.getConnectionForOrphanedConnection;

Connection.getConnectionForOrphanedConnection = (startBlock, orphanConnection) => {
  if (orphanConnection.type === Blockly.ConnectionType.OUTPUT_VALUE) {
    return null;
  }
  return original.call(Connection, startBlock, orphanConnection);
};
